import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindMethods } from '../index';

const search = (list, value) => {
  const lcValue = value.toLowerCase();
  return list.filter((element) => {
    return Object.keys(element).reduce((acc, key) => {
      if (typeof element[key] === 'string') {
        return (element[key].toLowerCase().indexOf(lcValue) !== -1) || acc;
      }
      return acc;
    }, false);
  });
};

export default class FilteredList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      list: props.list,
    };
    bindMethods(this, ['onChange']);
  }

  onChange(value) {
    this.setState({
      value,
      list: search(this.props.list, value),
    });
  }

  render() {
    const { onChange, state } = this;
    const { children } = this.props;
    const { value, list } = state;
    return children(list, value, onChange);
  }
}

FilteredList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  children: PropTypes.func.isRequired,
};
